import { Link } from "react-router-dom";
import { Mail, Flame } from "lucide-react";
import { BRAND_LOGOS, COMPANY, BRANDS } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-24 pb-10 border-t border-white/5 bg-[#080d18]"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-orange-500/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src={BRAND_LOGOS.mastersText}
              alt="Master Ready Services"
              className="h-12 w-auto mb-5"
            />
            <p className="font-body text-slate-400 text-sm max-w-md">
              {COMPANY.name} — helping contractors, home-service providers, restoration
              companies, and growing businesses connect with the opportunities that
              matter most.
            </p>

            <div className="mt-5 flex items-center gap-3 font-tech text-[11px] text-orange-400">
              <Flame size={14} />
              {COMPANY.tagline.toUpperCase()}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-tech text-[10px] text-slate-500 mb-4">DIVISIONS</div>
            <ul className="space-y-2">
              {BRANDS.map((b) => (
                <li key={b.key}>
                  <a
                    href="#brands"
                    className="font-body text-slate-300 hover:text-orange-300 transition-colors text-sm"
                    data-testid={`footer-brand-${b.key}`}
                  >
                    {b.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-tech text-[10px] text-slate-500 mb-4">NAVIGATE</div>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="font-body text-slate-300 hover:text-orange-300 text-sm">
                  Services
                </a>
              </li>
              <li>
                <a href="#leadership" className="font-body text-slate-300 hover:text-orange-300 text-sm">
                  Leadership
                </a>
              </li>
              <li>
                <a href="#reviews" className="font-body text-slate-300 hover:text-orange-300 text-sm">
                  Reviews
                </a>
              </li>
              <li>
                <Link to="/portal" className="font-body text-slate-300 hover:text-amber-300 text-sm">
                  Client Portal
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-tech text-[10px] text-slate-500 mb-4">CONTACT</div>
            <a
              href={`mailto:${COMPANY.email}`}
              className="flex items-center gap-2 font-body text-slate-300 hover:text-orange-300 text-sm break-all"
            >
              <Mail size={14} className="shrink-0" />
              {COMPANY.email}
            </a>
            <div className="mt-2 font-body text-slate-500 text-xs">
              {COMPANY.domain}
            </div>
          </div>
        </div>

        <div className="section-divider my-10" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-tech text-[10px] text-slate-500">
            © {new Date().getFullYear()} {COMPANY.name}. ALL RIGHTS RESERVED.
          </div>
          <div className="font-tech text-[10px] text-slate-500">
            HELPING BUSINESSES CONNECT WITH THE OPPORTUNITIES THAT MATTER MOST.
          </div>
        </div>
      </div>
    </footer>
  );
}
